import { CKButton } from 'clearkit';

import Logo from '~/components/ConfigurationLogo';
import SecurityDisclaimer from '~/components/ConfigurationSecurityDisclaimer';
import {
  configurationNameForType,
  configurations,
  purposeForConnectorService,
} from '~/lib/configuration';

import G2ConnectionForm from './G2ConnectionForm';
import GoogleAdsConnectionForm from './GoogleAdsConnectionForm';
import GoogleConnectionForm from './GoogleConnectionForm';
import MarketoConnectionForm from './MarketoConnectionForm';
import PardotConnectionForm from './PardotConnectionForm';
import SalesforceConnectionForm from './SalesforceConnectionForm';
import styles from './styles';

const documentationLinks = {
  [configurations.slack]:
    'https://help.clearbit.com/hc/en-us/articles/360022030174-Slack-Destination',
  [configurations.google]:
    'https://help.clearbit.com/hc/en-us/articles/360035758434-Google-Remarketing-Destination',
  [configurations.facebook]:
    'https://help.clearbit.com/hc/en-us/articles/360033672274-Facebook-Retargeting-Audience-Destination',
  [configurations.hubspot]:
    'https://help.clearbit.com/hc/en-us/articles/4420179541911',
  [configurations.salesforce]:
    'https://help.clearbit.com/hc/en-us/articles/360010028354-Syncing-your-Salesforce-data-with-Clearbit',
  [configurations.salesforcesandbox]:
    'https://help.clearbit.com/hc/en-us/articles/360010028354-Syncing-your-Salesforce-data-with-Clearbit',
  [configurations.pardot]:
    'https://help.clearbit.com/hc/en-us/articles/360010028354-Syncing-your-Salesforce-data-with-Clearbit',
};

const ConnectionForm = ({ classes, service, auth, onSuccess }) => {
  const purpose = purposeForConnectorService(service);
  const name = configurationNameForType(service);
  const isSalesforceService =
    service === configurations.salesforce ||
    service === configurations.salesforcesandbox;
  const isPardotService = service === configurations.pardot;

  const isGoogleService = service === configurations.google;
  const isGoogleAdsService = service === configurations.googleAds;

  const isHubspotService = service === configurations.hubspot;
  const isMarketoService = service === configurations.marketo;
  const isG2Service = service === configurations.g2;

  return (
    <div className={classes.disconnectedRoot}>
      <div className={classes.disconnectedContent}>
        <div className={classes.dottedLogo}>
          <Logo style={{ width: 40, height: 40 }} type={service} />
        </div>

        {(() => {
          if (isSalesforceService) {
            return (
              <>
                <SalesforceConnectionForm
                  onAuth={(salesforceService) => auth(salesforceService)}
                />
                <hr className={classes.break} />
                <SecurityDisclaimer className={classes.disclaimer} />
              </>
            );
          }

          if (isPardotService) {
            return <PardotConnectionForm auth={auth} onSuccess={onSuccess} />;
          }

          if (isGoogleService) {
            return <GoogleConnectionForm onAuth={auth} />;
          }

          if (isGoogleAdsService) {
            return <GoogleAdsConnectionForm onAuth={auth} />;
          }

          if (isMarketoService) {
            return <MarketoConnectionForm onSuccess={onSuccess} />;
          }

          if (isG2Service) {
            return <G2ConnectionForm />;
          }

          return (
            <>
              <span className={classes.connectorDescription}>
                Connect your {name} account to automatically start {purpose}.
                {documentationLinks[service] && (
                  <>
                    {' '}
                    Head to our {name} sync{' '}
                    <a
                      className={classes.link}
                      href={documentationLinks[service]}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      documentation
                    </a>{' '}
                    to learn more.
                  </>
                )}
              </span>

              <CKButton
                onClick={() => auth(service)}
                variant="bold"
                variantColor="blue"
              >
                <span>Connect {name}</span>
              </CKButton>

              {isHubspotService && (
                <>
                  <hr className={classes.break} />
                  <SecurityDisclaimer className={classes.disclaimer} />
                </>
              )}
            </>
          );
        })()}
      </div>
    </div>
  );
};

ConnectionForm.propTypes = {
  auth: PropTypes.func,
};

export default withStyles(styles)(ConnectionForm);
